import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";
import { num, has, r2 } from "@/lib/invoiceCalc";

const GRID_ITEM = "grid-cols-[minmax(0,1fr)_100px_76px_92px_32px]";
const GRID_MODE = "grid-cols-[minmax(0,1fr)_64px_80px_50px_70px_26px]";

export function TpRowsEditor({ rows, onChange, defaultBase, withMode = false, testPrefix }) {
  const upd = (i, patch) => onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const baseOf = (r) => (has(r.price) ? num(r.price) : defaultBase(r));
  const grid = `grid ${withMode ? GRID_MODE : GRID_ITEM} gap-1.5 items-center`;
  const inp = `h-8 px-1.5 min-w-0 w-full bg-white ${withMode ? "text-xs" : ""}`;
  return (
    <div className="space-y-1.5">
      <div className={`${grid} text-[11px] font-semibold text-slate-600 leading-tight`} data-testid={`${testPrefix}-header`}>
        <span className="pl-0.5">Narration</span><span className="text-right pr-1">Price (₹)</span>{withMode && <span className="pl-1">Apply</span>}
        <span className="text-center">TP (%)</span><span className="text-right pr-1">Total (₹)</span><span />
      </div>
      {rows.map((r, i) => {
        const base = baseOf(r); const total = r2(base + r2(base * num(r.percent) / 100));
        return (
          <div key={i} className={grid} data-testid={`${testPrefix}-row-${i}`}>
            <Input value={r.narration} onChange={(e) => upd(i, { narration: e.target.value })} placeholder="e.g. Scheme" className={inp} data-testid={`${testPrefix}-narration-${i}`} />
            <Input type="number" value={has(r.price) ? r.price : ""} placeholder={defaultBase(r).toFixed(2)} onChange={(e) => upd(i, { price: e.target.value })} className={`${inp} text-right font-mono`} data-testid={`${testPrefix}-price-${i}`} />
            {withMode && (
              <select value={r.mode || "before"} onChange={(e) => upd(i, { mode: e.target.value })} className="h-8 w-full min-w-0 rounded-md border border-slate-200 bg-white text-[11px] px-0.5" data-testid={`${testPrefix}-mode-${i}`}>
                <option value="before">Before</option><option value="after">After</option>
              </select>
            )}
            <Input type="number" step="any" value={r.percent} onChange={(e) => upd(i, { percent: e.target.value })} placeholder="±%" className={`${inp} text-center font-mono`} data-testid={`${testPrefix}-percent-${i}`} />
            <Input type="number" step="any" value={total} onChange={(e) => upd(i, { percent: base ? Number((((num(e.target.value) / base) - 1) * 100).toFixed(4)) : 0 })} className={`${inp} text-right font-mono`} data-testid={`${testPrefix}-total-${i}`} />
            <Button size="icon" variant="ghost" className="h-8 w-7" onClick={() => onChange(rows.filter((_, j) => j !== i))} data-testid={`${testPrefix}-delete-${i}`}><Trash2 className="h-4 w-4 text-red-500" /></Button>
          </div>
        );
      })}
      <Button size="sm" variant="outline" className="h-7 text-[#1A2A5E] bg-white" onClick={() => onChange([...rows, { narration: "", price: "", percent: "", mode: "before" }])} data-testid={`${testPrefix}-add`}><Plus className="h-3.5 w-3.5 mr-1" />Add TP</Button>
    </div>
  );
}
